import type { PracticalProject } from "../../data";

export const securityQualityDx: PracticalProject = {
  id: "security-quality-dx",
  num: 8,
  title: "実践プロジェクト⑧ 株式会社スミレクラウド セキュリティインシデント対応プロジェクト",
  description:
    "勤怠給与 SaaS「スミレ HR」で外部研究者から責任開示された脆弱性への対応案件。影響範囲の把握・対応優先順位付け・再発防止策の策定まで、セキュリティと品質の両面から意思決定に取り組む",
  duration: "5 日〜2 週間",
  techStack: [],
  difficulty: "beginner",
  phase: "Phase 3 後半",
  learningOutcomes: [
    "脆弱性報告の内容を正確に読み取り、影響範囲とリスクの大きさを評価できるようになる",
    "緊急対応と恒久対応のトレードオフを踏まえて、対応の優先順位を根拠とともに決定できるようになる",
    "再発防止のための開発プロセス (レビュー・テスト・監視) の改善案を具体的に提案できるようになる",
  ],
  chapters: [
    { num: 1, title: "インシデント発生と現状確認" },
    { num: 2, title: "対応方針と優先順位付け" },
    { num: 3, title: "再発防止策と提出" },
  ],
};
